export const CLOSED_BOARD_FIELDS = [
  'closed',
  'id',
  'idOrganization',
  'name',
  'memberships',
  'shortLink',
];

export const BOARD_FIELDS_MINIMAL = [
  'closed',
  'creationMethod',
  'dateLastActivity',
  'dateLastView',
  'datePluginDisable',
  'id',
  'idOrganization',
  'name',
  'prefs',
  'shortLink',
  'shortUrl',
  'url',
];

export const BOARD_FIELDS = BOARD_FIELDS_MINIMAL.concat([
  'desc',
  'descData',
  'idTags',
  'invitations',
  'invited',
  'labelNames',
  'limits',
  'memberships',
  'powerUps',
  'subscribed',
]);

export const CARD_FIELDS_MINIMAL = [
  'badges',
  'closed',
  'desc', // TODO: Not needed in minimal, but currently used for badge
  'idAttachmentCover',
  'idBoard',
  'idList',
  'idMembers',
  'labels',
  'name',
  'pos',
  'shortLink',
  'url',
];

export const LIST_FIELDS_MINIMAL = ['closed', 'idBoard', 'name', 'pos'];

export const MEMBER_FIELDS_MINIMAL = [
  'avatarHash',
  'avatarSource',
  'email',
  'fullName',
  'initials',
  'username',
  'bio',
  'prefs',
  'products',
  'loginTypes',
];

export const MEMBER_FIELDS_HEADER = [
  ...MEMBER_FIELDS_MINIMAL,
  'confirmed',
  'idEnterprisesAdmin',
  'idPremOrgsAdmin',
  'marketingOptIn',
  'messagesDismissed',
];

export const TEAM_FIELDS_MINIMAL = [
  'name',
  'displayName',
  'products',
  'prefs',
  'limits',
  'logoHash',
  'idEnterprise',
  'tags',
  'url',
];

export const TEAM_FIELDS = TEAM_FIELDS_MINIMAL.concat([
  'desc',
  'descData',
  'website',
  'memberships',
]);



// WEBPACK FOOTER //
// ./app/gamma/src/modules/loaders/fields.ts